export default __webpack_public_path__ + "static/media/whatsapp.ba7293b8.png";